export default __webpack_public_path__ + "static/media/action-cam-2.8d9e2000.png";